<template>
  <div>
    <div id="main-map">
      <div class="mapboxgl-ctrl-bottom-right cuny-logo">
        <a href="https://www.gc.cuny.edu/CUR" target="_blank"><img src="cuny-gc-logo.png" /></a>
      </div>
      <div class="mapboxgl-ctrl-bottom-right third-party-container">
        <a v-for="logo in $mainConfig['map-logos']" :key="logo.link" :href="logo.link" target="_blank">
          <img class="third-party-logo" :src="logo['img-src']" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import mapboxgl from "mapbox-gl";

import Vue from "vue";
import { EventBus } from "../js/DataManagement/EventBus";
import EventManager from "../js/DataManagement/EventMangager";
export default {
  name: "Map",
  data: function () {
    return {
      viewNeedsUpdate: false,
      marker: null,
    };
  },
  mounted: function () {
    mapboxgl.accessToken = this.$mainConfig.api.keys.CUNYMapBoxKey;
    this.map = new mapboxgl.Map(this.$mainConfig.mapConfig);
    let map = (Vue.prototype.$map = this.map);
    Vue.prototype.$eventManager = new EventManager();

    let self = this;

    this.map.addControl(new mapboxgl.NavigationControl(), "bottom-left");

    map.once("idle", () => {
      self.$layerManager.addLayersToMap(self.map);
      self.$layerManager.initToggledLayersFromUrl(self.map);
    });

    map.on("mousemove", () => {
      map.getCanvas().style.cursor = "crosshair";
    });

    map.on("mouseout", () => {
      map.getCanvas().style.cursor = "";
    });

    map.on("click", function (e) {
      self.addMarker(e);
      EventBus.$emit("clearAddress");
      self.$store.commit("setSelectedLngLat", [e.lngLat.lng, e.lngLat.lat]);
      EventBus.$emit("select-from-click", [e.lngLat.lng, e.lngLat.lat]);
    });

    EventBus.$on("zoomToState", () => {
      const stateFips = self.$store.getters.getSelectedState
      // from statedata get bounding box
      const selectedState = this.$stateData.states.find(state => state.statefips === stateFips)
      if (selectedState && selectedState.bbox) {
        const wktPolygon = selectedState.bbox;

        // Extract coordinates from WKT
        const coordsString = wktPolygon.match(/POLYGON\(\((.*)\)\)/)[1];
        const coordPairs = coordsString.split(',').map(pair => {
          const [lng, lat] = pair.trim().split(' ');
          return [parseFloat(lng), parseFloat(lat)];
        });


        // Create bounds [minLng, minLat, maxLng, maxLat]
        const bounds = [
          Math.min(...coordPairs.map(c => c[0])),
          Math.min(...coordPairs.map(c => c[1])),
          Math.max(...coordPairs.map(c => c[0])),
          Math.max(...coordPairs.map(c => c[1]))
        ];

        map.fitBounds(bounds, { padding: 20 });
      }
    })

    EventBus.$on("add-marker", (lat, lng) => {
      self.addMarker({
        lngLat: {
          lng,
          lat,
        },
      });
    });

    EventBus.$on("clear-selected-districts", () => {
      if (self.marker) {
        self.marker.remove();
        self.marker = null;
      }
    });

    EventBus.$on("zoom-to-districts", () => {
      self.$nextTick(() => {
        self.calculateBBox();
      });
    });

  },
  methods: {
    calculateBBox: function () {
      let self = this;

      const proposalA = this.$store.getters.getSideAid;
      const geoidA = this.$store.getters.getSelectedDistrictSideA;
      const proposalB = this.$store.getters.getSideBid;
      const geoidB = this.$store.getters.getSelectedDistrictSideB;

      if (geoidA.length > 0 || geoidB.length > 0) {
        Promise.all(
          self.$dataManager.getNewBBoxView(proposalA, geoidA, proposalB, geoidB)
        ).then((responses) => {
          var bounds = new mapboxgl.LngLatBounds();
          responses.forEach((resp) => {
            const extendBnds = resp.data[0].bbox
              .replace("BOX(", "")
              .replace(")", "")
              .split(",");
            bounds.extend(extendBnds[0].split(" "));
            bounds.extend(extendBnds[1].split(" "));
          });

          const padding = {
            top: 200,
            bottom: 50,
            right: 50,
            left: 50,
          };

          self.map.fitBounds(bounds, { padding });
          // console.log(bounds);
        });
      }
    },
    addMarker(e) {
      let self = this;
      if (self.marker) {
        self.marker.remove();
      }

      self.$querystringManager.addQueryParam(
        "selected",
        [e.lngLat.lng.toFixed(3), e.lngLat.lat.toFixed(3)].join(",")
      );

      self.marker = new mapboxgl.Marker({
        color: self.$styleConfig.styles["marker-color"],
        draggable: false,
      }).setLngLat(e.lngLat);

      self.marker.addTo(self.$map);
    },
  },
  computed: {
    sideAId: function () {
      return this.$store.getters.getSideAid;
    },
    sideBId: function () {
      return this.$store.getters.getSideBid;
    },
    selectedDistrictSideA: function () {
      return this.$store.getters.getSelectedDistrictSideA;
    },
    selectedDistrictSideB: function () {
      return this.$store.getters.getSelectedDistrictSideB;
    },
  },
  watch: {
    selectedDistrictSideA: function () { },
    selectedDistrictSideB: function () { },
  },
};
</script>
<style scoped>
/* #main-map {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0px;
  cursor: crosshair;
} */
#main-map {
  width: 100%;
  height: 100vh;
}

.mapboxgl-ctrl-bottom-right {
  pointer-events: auto;
}
</style>
<style>
.mapboxgl-ctrl-attrib-inner {
  display: inline-block;
}

.cuny-logo {
  transform: translate(-10px, -45px);
}

.third-party-logo {
  max-height: 40px;
  max-width: 110px;
  padding: 0 5px;
}

.third-party-container {
  transform: translate(-100px, -15px);
}
</style>
